"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ComposerSettings;

var _ActionTypes = _interopRequireDefault(require("composer-lib/redux/ActionTypes"));

function ComposerSettings() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.default.SET_COMPOSER_COMPOSITION_ID:
      return state.set('compositionId', action.data);

    default:
      return state;
  }
}

module.exports = exports.default;